import * as Redux from 'redux'
import * as Types from './types'
import * as Utils from './utils'

export interface DragAction extends Redux.Action {
  item: Types.DraggableItem,
}

type DragActionCreator = (prefix: string, item: Types.DraggableItem) => DragAction

export const dragStart: DragActionCreator = (prefix: string, item: Types.DraggableItem) => {
  return ({
    item,
    type: Utils.startDragCellConstant(prefix),
  })
}

export const dragEnd: DragActionCreator = (prefix: string, item: Types.DraggableItem) => {
  return ({
    item,
    type: Utils.endDragCellConstant(prefix),
  })
}

export const dragOver: DragActionCreator = (prefix: string, item: Types.DraggableItem) => {
  return ({
    item,
    type: Utils.reorderDragCellConstant(prefix),
  })
}



// WEBPACK FOOTER //
// ./src/components/drag-cell/actions.ts